import cloneDeep from 'lodash/cloneDeep'
import { MARKETPLACE_SETTINGS_EDIT_ACTION_TYPES } from 'utils/actions/loadBoardPosts'
import { SHIPMENT_ACTION_TYPES } from 'utils/actions/shipment'
import { DAT_FLAGS } from 'apps/booking/constants/loadBoardPosts'
import { formatCurrency, formatPerMile } from 'utils/formatCurrency'
import { SIDEBAR_ACTION_TYPES } from '../actions/sidebar'
import { formatShipmentSidePanel } from '../formatShipment'

const defaultState = {
  open: false,
  loading: false,
  activeRowId: null,
  type: 'shipment',
  data: { shipment: null },
  error: null,
  isUpdatingShipment: false,
  updatedShipmentField: '',
}

const { SIDEBAR_CLOSED, SIDEBAR_EXTRA, SIDEBAR_OPEN, SIDEBAR_REQUESTED } = SIDEBAR_ACTION_TYPES

const { SHIPMENT_SUCCESS } = SHIPMENT_ACTION_TYPES

const { MARKETPLACE_SETTINGS_EDIT_SUCCESS } = MARKETPLACE_SETTINGS_EDIT_ACTION_TYPES

const sidebarReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case 'FETCH_SHIPMENT_REQUEST': {
      return {
        ...state,
        isUpdatingShipment: true,
        error: '',
      }
    }
    case 'FETCH_SHIPMENT_FAIL': {
      return {
        ...state,
        isUpdatingShipment: false,
        error: action.error,
      }
    }
    case 'FETCH_SHIPMENT_SUCCESS': {
      return {
        ...state,
        error: '',
        isUpdatingShipment: false,
        data: {
          ...state.data,
          shipment: formatShipmentSidePanel(action.payload.shipment),
        },
      }
    }
    case 'SHIPMENT_FIELD_UPDATED': {
      return {
        ...state,
        updatedShipmentField: action.payload,
      }
    }
    case SIDEBAR_REQUESTED: {
      return {
        ...state,
        updatedShipmentField: '',
        open: true,
        loading: true,
        data: { shipment: {} },
        activeRowId: action.payload.id,
        error: null,
      }
    }
    case SHIPMENT_SUCCESS: {
      const {
        error,
        id: activeRowId,
        payload: { shipment: data },
      } = action
      return {
        ...state,
        open: true,
        loading: false,
        activeRowId: activeRowId || data?.id,
        data: {
          ...state.data,
          shipment: formatShipmentSidePanel(data),
        },
        error,
      }
    }
    case MARKETPLACE_SETTINGS_EDIT_SUCCESS: {
      const {
        payload: {
          requestData: { body },
        },
      } = action
      const { marketOnLoadBoards, marketOnMarketplace, rate: listRate } = body
      const updatedShipment = cloneDeep(state.data.shipment)
      const updatedFlags = new Set(updatedShipment.flags)

      if (marketOnMarketplace) {
        updatedFlags.add(DAT_FLAGS.marketOnMarketplace)
      } else {
        updatedFlags.delete(DAT_FLAGS.marketOnMarketplace)
      }
      if (marketOnLoadBoards) {
        updatedFlags.add(DAT_FLAGS.marketOnLoadBoards)
      } else {
        updatedFlags.delete(DAT_FLAGS.marketOnLoadBoards)
      }

      updatedShipment.flags = updatedFlags
      updatedShipment.carrierPayment.tcmCarrierPrices.listPrice = listRate

      // TODO: formattedCurrency should not be nessecary, remove and read values directly and format on presentation layer
      updatedShipment.formattedCurrency.listRateAmount = formatCurrency(listRate)
      updatedShipment.formattedCurrency.listRatePerMile = formatPerMile(
        listRate,
        updatedShipment.info.totalMiles
      )

      return {
        ...state,
        data: {
          ...state.data,
          shipment: updatedShipment,
        },
      }
    }
    // TODO: Refactor to not use SIDEBAR_OPEN
    case SIDEBAR_OPEN: {
      const {
        payload: { data, error, id: activeRowId },
      } = action
      if (activeRowId === state.activeRowId) {
        return {
          ...state,
          open: true,
          loading: false,
          activeRowId,
          data: {
            ...state.data,
            shipment: formatShipmentSidePanel(data),
          },
          error,
        }
      }
      return { ...state }
    }
    case SIDEBAR_EXTRA: {
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.type]: action.payload.data,
        },
      }
    }
    case SIDEBAR_CLOSED: {
      return {
        ...state,
        open: false,
        loading: false,
        activeRowId: null,
        error: null,
      }
    }
    default:
      return state
  }
}

export default sidebarReducer
